import type React from 'react';

import { cn } from '@/lib/utils';

import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

export type SidebarItemProps = {
  icon?: React.ReactNode;
  label: string;
  className?: string;
  isSidebarCollapsed?: boolean;
  onClick?: () => void;
};

export const SidebarItem = ({
  icon,
  label,
  className,
  isSidebarCollapsed,
  onClick,
}: SidebarItemProps) => {
  const link = (
    <button
      type="button"
      className={cn(
        'flex min-h-[41px] w-full cursor-pointer items-center gap-[12px] rounded-md px-6 py-2 text-md leading-tight text-primary-darker hover:bg-primary-darker/10 max-md:px-2 [&_svg]:size-6 [&_svg]:shrink-0 [&_svg]:text-primary',
        className,
        isSidebarCollapsed && 'justify-center px-2'
      )}
      onClick={onClick}
    >
      {icon ? icon : null}
      {isSidebarCollapsed ? null : label}
    </button>
  );

  return isSidebarCollapsed ? (
    <Tooltip>
      <TooltipTrigger>{link}</TooltipTrigger>
      <TooltipContent
        side="right"
        className="bg-primary-dark py-1 text-base text-primary-lighter shadow [&_polygon]:fill-primary-dark [&_svg]:bg-primary-dark"
      >
        {label}
      </TooltipContent>
    </Tooltip>
  ) : (
    link
  );
};
